import { z } from "zod";

import { Logger } from "@abacus/common";
import {
  terminateContractBody,
  terminateContractParams,
} from "@abacus/ows-contract-client/zod";
import { TerminateContractRequest } from "./types";

export const terminateContractsJobConfigSchema = z
  .object({
    logger: (z.unknown() as z.ZodType<Logger>).optional(),
  })
  .optional();

export const terminateContractsJobDataSchema = z.object({
  requests: z.array(
    terminateContractParams.merge(
      terminateContractBody,
    ) as unknown as z.ZodType<TerminateContractRequest>,
  ),
});
